import { useDispatch } from 'react-redux';
import Warning from '../assets/images/WarningOctagon.png'
import { RemoveName } from '../services/manageUserServices';
import { toast } from 'react-toastify';
import { fetchUsers } from '../redux/slices/userSlice';
import { useEffect } from 'react';

export default function ConfirmDeactivate({ isOpen, onClose, item }) {
  const dispatch = useDispatch();

  useEffect(() =>{
    dispatch(fetchUsers())
  }, [dispatch])

  const deleteFn = async () => {
      try {
        const res = await RemoveName(item?.userName);
        if (res.statusCode === 200) {
          dispatch(fetchUsers());
          toast.success(res.message);
          onClose();
        } else if(res?.statusCode === 404){
          toast.error(res.message)
        } else {
          toast.error(res.message);
        }
      } catch (error) {
        toast.error("Failed to delete user. Please try again.");
      }
    };

  if (!isOpen) return null;

  return (
    <div className="modal fixed inset-0 bg-orange/20 backdrop-blur-[1px] grid place-items-center">
      <div className="bg-white rounded-2xl py-5 px-4 max-w-md">
        <div className="flex justify-center rounded-full">
          <img src={Warning} alt="" className="bg-[#eec4c4] rounded-full" />
        </div>
        <div className="mt-5">
          <h2 className="text-4xl text-primaryRed text-center">Confirm Delete</h2>
          <div>
            <p className="text-center py-4">
              Are you sure you want to delete this user?
            </p>
          </div>
          <div className="flex items-center justify-center gap-x-6 mt-5">
            <button
              className="text-primaryRed border border-[#FFB0B0] px-6 py-2 text-center rounded-md w-full hover:bg-[#FFB0B0]"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="text-white border border-primryRed bg-primaryRed px-6 py-2 text-center rounded-md hover:bg-primaryRed/80 w-full"
              onClick={deleteFn}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

